/* import __COLOCATED_TEMPLATE__ from './labels-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface CellLabelsCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
    scrollToRow: unknown;
  };
}

const CellLabelsCellComponent = templateOnlyComponent<CellLabelsCellSignature>();

export default CellLabelsCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::LabelsCell': typeof CellLabelsCellComponent;
    'cell/labels-cell': typeof CellLabelsCellComponent;
  }
}
